<script>
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {ref, watch} from "vue";
import {useRecruitmentCvTechStore} from "@/stores/Recruitment/RecruitmentCvTech.js";
import CvTechFilter from "@/views/Recruitment/CvTech/Components/CvTechFilter.vue";
import axios from "axios";

export default {
    components: {CvTechFilter},
    setup() {
        const {
            loading,
            total,
            itemsPerPage,
            filter,
        } = useSharedData();

        const {transformFilterValues} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const recruitmentCvTechStore = useRecruitmentCvTechStore();

        const headers = [
            {
                text: $i18n.t('common.last_name'),
                sortable: true,
                align: "left",
                value: "lastName",
                width: "0%"
            },
            {
                text: $i18n.t('common.first_name'),
                sortable: true,
                align: "left",
                value: "firstName",
                width: "0%"
            },
            {
                text: $i18n.t('data_select.RECRUITMENT_CV_TECH_SPECIALITY'),
                sortable: true,
                align: "left",
                value: "specialityName",
                width: "0%"
            },
            {
                text: $i18n.t('common.country_state'),
                sortable: true,
                align: "left",
                value: "stateName",
                width: "0%"
            },
            {
                text: $i18n.t('common.phone'),
                sortable: true,
                align: "left",
                value: "phone",
                width: "0%"
            },


            {
                text: $i18n.t('common.address'),
                sortable: true,
                align: "left",
                value: "address",
                width: "0%"
            },
            {
                text: $i18n.t('common.email'),
                sortable: true,
                align: "left",
                value: "email",
                width: "0%"
            },
        ];

        const searchParams = ref({
            sortBy: "lastName",
            descending: false,
            page: 1,
            itemsPerPage: itemsPerPage
        });

        function handleSearch(params) {
            loading.value = true;
            recruitmentCvTechStore.setRecruitmentCvTechs([]);
            total.value = 0;

            loading.value = true;
            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;

            axios.get('/cvTechs', {params: transformFilterValues(filter.value)}).then((response) => {
                recruitmentCvTechStore.setRecruitmentCvTechs(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });

        }

        function findAll() {
            handleSearch(searchParams.value)
        }

        watch(() => filter.value, () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});

        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});

        function view(item) {
            $router.push({name: "recruitment_cv_techs.view", params: {id: item.id}});
        }

        return {
            recruitmentCvTechStore,
            searchParams,
            headers,
            loading,
            total,
            filter,
            findAll,
            view,
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.cv_tech')"
            show-filter
            :filter="filter"
            :total="total"
        >
            <template #filter>
                <CvTechFilter :filter="filter"/>
            </template>
            
            <template #rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
            </template>

            <template #content>
                <w-server-data-table
                    v-model="searchParams"
                    :headers="headers"
                    :items="recruitmentCvTechStore.recruitmentCvTechs"
                    :loading="loading"
                    :total="total"
                    root-path="recruitment_cv_techs"
                    module="RECRUITMENT_CV_TECH"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.lastName`]="{ item }">
                        <w-inline-text bold :text="item.lastName"/>
                    </template>
                    <template v-slot:[`item.firstName`]="{ item }">
                        <w-inline-text bold :text="item.firstName"/>
                    </template>
                    <template v-slot:[`item.stateName`]="{ item }">
                        <w-inline-text :text="item.stateName"/>
                    </template>
                    <template v-slot:[`item.address`]="{ item }">
                        <w-inline-text :text="item.address"/>
                    </template>
                    <template v-slot:[`item.specialityName`]="{ item }">
                        <w-inline-text :text="item.specialityName"/>
                    </template>
                    <template v-slot:[`item.email`]="{ item }">
                        <w-inline-text :text="item.email"/>
                    </template>
                    <template v-slot:[`item.phone`]="{ item }">
                        <w-inline-text :text="item.phone"/>
                    </template>
                </w-server-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>